import { render } from "./BO.vue?vue&type=template&id=6da289cf"
import script from "./BO.vue?vue&type=script&lang=js"
export * from "./BO.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__